"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorSetFromConfiguration = exports.getHighlightColor = exports.getDarkerColor = exports.getValidColor = exports.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR = exports.ACCENT_MULTIPLIER = exports.DEFAULT_ACCENT_COLOR_2 = exports.DEFAULT_ACCENT_COLOR_1 = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_BACKGROUND_COLOR = void 0;
var color_1 = __importDefault(require("color"));
exports.DEFAULT_BACKGROUND_COLOR = '#fafbfc';
exports.DEFAULT_TEXT_COLOR = '#515A61';
exports.DEFAULT_ACCENT_COLOR_1 = '#ff3d33';
exports.DEFAULT_ACCENT_COLOR_2 = '#0e66e1';
exports.ACCENT_MULTIPLIER = 0.1;
exports.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR = '#d6d6d6';
var black = new color_1.default('black');
var white = new color_1.default('white');
var getValidColor = function (color, defaultValue) {
    if (!color)
        return defaultValue;
    try {
        return new color_1.default(color).hex().toString();
    }
    catch (_a) {
        return defaultValue;
    }
};
exports.getValidColor = getValidColor;
var getDarkerColor = function (base, ratio) {
    return new color_1.default(base).darken(ratio).hex().toString();
};
exports.getDarkerColor = getDarkerColor;
var getHighlightColor = function (base, ratio) {
    var baseColor = new color_1.default(base);
    var highlightColor = baseColor.isLight()
        ? baseColor.mix(black, ratio)
        : baseColor.mix(white, ratio * 4);
    return highlightColor.hex().toString();
};
exports.getHighlightColor = getHighlightColor;
var getColorSetFromConfiguration = function (siteConfiguration) {
    var background = (0, exports.getValidColor)(siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['custom-header-background-color'], exports.DEFAULT_BACKGROUND_COLOR);
    var backgroundBorder = (0, exports.getHighlightColor)(background, exports.ACCENT_MULTIPLIER);
    var backgroundHighlight = (0, exports.getHighlightColor)(background, exports.ACCENT_MULTIPLIER * 0.5);
    var text = (0, exports.getValidColor)(siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['custom-header-text-color'], exports.DEFAULT_TEXT_COLOR);
    var accent1 = (0, exports.getValidColor)(siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['custom-header-accent-color-1'], exports.DEFAULT_ACCENT_COLOR_1);
    var accent2 = (0, exports.getValidColor)(siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['custom-header-accent-color-2'], exports.DEFAULT_ACCENT_COLOR_2);
    return {
        background: background,
        backgroundBorder: backgroundBorder,
        backgroundHighlight: backgroundHighlight,
        text: text,
        accent1: accent1,
        accent2: accent2,
    };
};
exports.getColorSetFromConfiguration = getColorSetFromConfiguration;
